module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/6_78d5f9dcbb7e6295479b38cd944e74a5.png";